import { render, staticRenderFns } from "./DStatsProgress.vue?vue&type=template&id=4738523c&"
import script from "./DStatsProgress.vue?vue&type=script&lang=js&"
export * from "./DStatsProgress.vue?vue&type=script&lang=js&"
import style0 from "./DStatsProgress.vue?vue&type=style&index=0&id=4738523c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports